/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
-----------------------------------------------------------------------------*/

<template>
  <div class="flex-container advanced-recordings">
    <div>
      <h2>Advanced Options for Testing Recordings</h2>
      If you are a customer seeing these options, please contact Support.
      These options are used for internal testing and may have been
      accidentally enabled for your account.<br><br>
      <label
        for="debugLanguage"
      >
        Language:
      </label>
      <select
        id="debugLanguage"
        v-model="language"
        @input="loadFormData"
      >
        <option
          v-for="(name, val) in languages"
          :value="val"
          :selected="val === 'en-US' ? 'selected' : ''"
        >
          {{ name }}
        </option>
      </select>
      <br><br>
      <label
        for="orgGroup"
      >
        orgGroup:
      </label>
      <select
        id="orgGroup"
        v-model="orgGroup"
        @input="loadFormData"
      >
        <option
          value="default"
          selected
        >
          None
        </option>
        <option
          value="customIdeals"
        >
          customIdeals
        </option>
        <option
          value="clearSlide"
        >
          clearSlide
        </option>
      </select>
      <br><br>
      <label
        for="diarization"
      >
        Diarization
      </label><br>
      <textarea
        id="diarization"
        v-model="diarization"
        @input="loadFormData"
      />
      <br><br>


      <label
        for="transcription"
      >
        Transcription
      </label><br>
      <textarea
        id="transcription"
        v-model="transcription"
        @input="loadFormData"
      />
      <br><br>

      <label
        for="metadata"
      >
        Metadata
      </label><br>
      <textarea
        id="metadata"
        v-model="metadata"
        @input="loadFormData"
      />
      <br><br>

      <label
        for="wordspotting"
      >
        wordspotting
      </label><br>
      <textarea
        id="wordspotting"
        v-model="wordspotting"
        @input="loadFormData"
      />
      <br><br>

      <label
        style="font-size: 13pt;"
      >
        Operations
      </label><br>
      <label
        for="operations1"
        style="display: block;"
      >
        <input
          id="operations1"
          v-model="operations"
          tabindex="0"
          type="radio"
          name="operations"
          value="[&quot;transcription&quot;, &quot;vv_analysis&quot;]"
          @input="loadFormData"
        >
        Transcription and VoiceVibes
      </label>
      <label
        for="operations2"
        style="display: block;"
      >
        <input
          id="operations2"
          v-model="operations"
          tabindex="0"
          type="radio"
          name="operations"
          value="[&quot;transcription&quot;]"
          @input="loadFormData"
        >
        Transcription Only
      </label>
      <br><br>

      <label
        for="transcriptionWebhook"
        style="display: block;"
      >
        <input
          id="transcriptionWebhook"
          v-model="transcriptionWebhook"
          type="text"
          class="form-control"
          placeholder="transcriptionWebhook"
          name="transcriptionWebhook"                    
        >
        Transcription Webhook
      </label>
      <br><br>

      <label
        for="vvAnalysisWebhook"
        style="display: block;"
      >
        <input
          id="vvAnalysisWebhook"
          v-model="vvAnalysisWebhook"
          type="text"
          class="form-control"
          placeholder="vvAnalysisWebhook"
          name="vvAnalysisWebhook"                    
        >
        Voicevibes Analysis Webhook
      </label>
      <br><br>

      <label
        for="transcriptionWebhook"
        style="display: block;"
      >
        <input
          id="videoTrimmingWebhook"
          v-model="videoTrimmingWebhook"
          type="text"
          class="form-control"
          placeholder="videoTrimmingWebhook"
          name="videoTrimmingWebhook"                    
        >
        Video Trimming Webhook
      </label>
      <br><br>
    </div>
  </div>
</template>

<style lang="less">
</style>

<script>

export default {
  props: ['groups', 'users', 'mode', 'multiple'],
  data() {
    return {
      language: 'en-US',
      orgGroup: 'default',
      diarization: '',
      metadata: '',
      transcription: '',
      wordspotting: '',
      languages: {
        'en-US': 'en-US - US English',
        'es-ES': 'es-ES - Spanish (castillian)',
        'en-AU': 'en-AU - Australian English',
        'en-GB': 'en-GB - British English',
        'de-DE': 'de-DE - German',
        'pt-BR': 'pt-BR - Brazillian portuguese',
        'zh-CN': 'zh-CN - Mandarin Chinese – Mainland',
        'fr-FR': 'fr-FR - French',
        'fr-CA': 'fr-CA - Canadian French',
        'ja-JP': 'ja-JP - Japanese',
        'ko-KR': 'ko-KR - Korean',
      },
      operations: '["transcription", "vv_analysis"]',
      transcriptionWebhook: '',
      vvAnalysisWebhook: '',
      videoTrimmingWebhook: ''
    };
  },
  computed: {
  },
  methods: {
    loadFormData() {
      // We need nextTick to get the updated values
      this.$nextTick(() => {
        let devFormData = {
          language: this.language,
          orgGroup: this.orgGroup,
          operations: this.operations,
          transcriptionWebhook: this.transcriptionWebhook,
          vvAnalysisWebhook: this.vvAnalysisWebhook,
          videoTrimmingWebhook: this.videoTrimmingWebhook
        };

        ['diarization', 'transcription', 'wordspotting', 'metadata'].forEach((field) => {
          try {
            if (this[field] && JSON.parse(this[field])) {
              devFormData[field] = JSON.parse(this[field]);
            }
          } catch(err) {}
        });

        return this.$emit('devFormData', devFormData);
      });
    },
  }
};
</script>
